// Preview displays the exact PNG fetched again after the deletion/ownership gate.
export class SummaryCardSession {
    public choices: any[] = [];
    public choiceId = '';
    public includeNickname = false;
    public nickname = '';
    public showTitle = true;
    public showAdvice = true;
    public reviewed = false;
    public open = false;
    public busy = false;
    public message = '';
    public url = '';
    public artifact: any = null;
    private serial = 0;
    get selected() { return this.choices.find(c => c.id === this.choiceId); }
    constructor(private request: (path: string, method?: string, body?: any) => Promise<any>, private runId: () => string) {}
    invalidate() {
        this.serial++; this.busy = false; this.reviewed = false; this.artifact = null;
        if (this.url) URL.revokeObjectURL(this.url);
        this.url = '';
    }
    clear() {
        this.invalidate(); this.open = false; this.choices = []; this.choiceId = ''; this.nickname = '';
        this.includeNickname = false; this.showTitle = true; this.showAdvice = true; this.message = '';
    }
    edit(key: string, event: Event) {
        const input = event.target as HTMLInputElement;
        if (key === 'reviewed') { this.reviewed = input.checked; return; }
        this.invalidate();
        if (key === 'choiceId') this.choiceId = input.value;
        if (key === 'nickname') this.nickname = input.value;
        if (key === 'includeNickname') this.includeNickname = input.checked;
        if (key === 'showTitle') this.showTitle = input.checked;
        if (key === 'showAdvice') this.showAdvice = input.checked;
        this.message = '표시 항목을 변경했습니다. 미리보기를 다시 만들어 주세요.';
    }
    async load() {
        this.clear(); this.open = true; this.busy = true;
        const serial = this.serial, id = this.runId();
        try {
            const value = await this.request('/' + id + '/summary-card');
            if (serial !== this.serial) return;
            this.choices = value.choices; this.choiceId = ''; this.message = value.message;
        } catch { if (serial === this.serial) this.message = '표현을 불러오지 못했습니다. 연결과 원본 결과를 확인해 주세요.'; }
        finally { if (serial === this.serial) this.busy = false; }
    }
    async prepare() {
        if (this.busy || !this.selected) return;
        this.invalidate(); this.busy = true;
        const serial = this.serial, id = this.runId();
        const body = { choice_id: this.choiceId, include_nickname: this.includeNickname, nickname: this.nickname, show_title: this.showTitle, show_advice: this.showAdvice };
        try {
            const artifact = await this.request('/' + id + '/summary-card', 'POST', body);
            if (serial !== this.serial) return;
            this.artifact = artifact;
            const bytes = Uint8Array.from(atob(artifact.png_base64), c => c.charCodeAt(0));
            this.url = URL.createObjectURL(new Blob([bytes], { type: 'image/png' }));
            this.message = '한글 글꼴 준비 완료 · 아래 이미지가 저장될 파일입니다. 문구와 별명·개인정보 포함 여부를 확인해 주세요.';
        } catch (error: any) {
            if (serial !== this.serial) return;
            this.message = error.code === 'CARD_TOO_LONG' ? '문구가 너무 깁니다. 더 짧은 원문 문단·조언을 선택해 주세요. 글자를 줄이거나 생략하지 않았습니다.' :
                error.code === 'CARD_NICKNAME' ? '별명은 80자·3줄 이내로 입력해 주세요.' :
                error.code === 'CARD_SOURCE_CHANGED' ? '원문 버전을 확인할 수 없습니다. 표현 목록을 다시 열어 주세요.' :
                [401,403,404].includes(error.status) ? '원본 결과가 없거나 접근할 수 없어 저장을 차단했습니다.' :
                '한글 글꼴 또는 이미지 준비를 완료하지 못했습니다. 잠시 후 다시 시도해 주세요.';
        } finally { if (serial === this.serial) this.busy = false; }
    }
    async download() {
        if (this.busy || !this.artifact || !this.reviewed) return;
        this.busy = true; const serial = this.serial, expected = this.artifact, id = this.runId();
        try {
            // Never download a cached Blob solely because an old preview exists.
            const value = await this.request('/' + id + '/summary-card?key=' + expected.key);
            if (serial !== this.serial) return;
            if (value.sha256 !== expected.sha256 || value.png_base64 !== expected.png_base64) throw new Error('changed');
            const link = document.createElement('a'); link.href = this.url; link.download = 'f1-summary-card.png'; link.click();
            this.message = '이미지 다운로드를 요청했습니다. 내려받은 파일은 결과를 삭제해도 회수할 수 없습니다.';
        } catch {
            if (serial !== this.serial) return;
            this.invalidate(); this.message = '원본 삭제·권한·보관 기간을 확인하지 못해 새 파일 저장을 차단했습니다. 원본을 확인한 뒤 다시 준비해 주세요.';
        } finally { if (serial === this.serial) this.busy = false; }
    }
}
